import { BREAK_TYPE } from './constant.js';
import { breakElementToHtml } from './element-to-html.js';
import { breakHtmlToElement } from './html-to-element.js';
import { breakPlugin } from './plugin.js';
import { breakRenderElement } from './render-element.js';
import { breakSerializer } from './serializer.js';

const BreakModule = {
  type: BREAK_TYPE,
  renderElement: breakRenderElement,
  elementToHtml: breakElementToHtml,
  htmlToElement: breakHtmlToElement,
  plugin: breakPlugin,
  serializer: breakSerializer
};

export { BreakModule };
//# sourceMappingURL=module.js.map
